const types = require('../../constants/actionTypes');

const switched = ({ index }) => ({
    type: types.TAB_SWITCHED,
    payload: { index },
});

module.exports = switched;
